import { useCallback, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { getStableMQTTConnectionTime } from "../selectors/mqttSelecor";
import { IntervalTimes } from "../constans/intervals";

export default function useMQTTFetcher(callback) {

    const mqttConnected = useSelector(getStableMQTTConnectionTime);

    const timer = useRef(null);

    const onVisibilityChange = useCallback(() => {
        if (document.visibilityState === "visible") {
            console.log("[useMQTTFetcher] Executing callback onVisibilityChange");
            callback();
            clearInterval(timer.current);
            timer.current = setInterval(callback, IntervalTimes.DEVICE_MQTT_RESEND_STATE);
        }
    }, [callback]);

    useEffect(() => {
        if (mqttConnected) {
            console.log("[useMQTTFetcher] Executing callback useEffect");
            callback();
            timer.current = setInterval(callback, IntervalTimes.DEVICE_MQTT_RESEND_STATE);
        }

        document.addEventListener('visibilitychange', onVisibilityChange);

        return () => {
            console.log("[useMQTTFetcher] Clearing interval");
            clearInterval(timer.current);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        }
    }, [callback, mqttConnected, onVisibilityChange]);
}